export class BrandNotFoundError extends Error {
  constructor() {
    super(`Brand not found`);
  }
}
